import { Component, OnInit } from '@angular/core';
import { ThemeService } from '../theme/theme-service.service';
import { SideNavBarVisibilityService } from './../services/side-nav-bar-visibility.service';

@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls: ['./sign-up.component.scss'],
    standalone: false
})
export class SignUpComponent implements OnInit {

  constructor(public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService) { }

  ngOnInit() {
    this.sideNavBarVisibilityService.hideSideNav = true;
  }

  ngOnDestroy() {
    this.sideNavBarVisibilityService.hideSideNav = false;
  }

}
